// index.jsx
import Events from './Events';

export default Events;
